export default "__VITE_ASSET__BIZL$j7v__"